import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class InsuranceRatesAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'insurance-rates' });
  }

  async fetchByState(state) {
    const response = await handleApiCalls('get', this.baseUrl, {
      params: { state },
    });
    return response.data;
  }
}

export default InsuranceRatesAPI;
